// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const my = {
  games: `ဂိမ်းများ`,
  game_history: `ဂိမ်းသမိုင်း`,
  bet_amount: `အမ်းခြေမှုပမာဏ`,
  login: `အကောင့်သို့ဝင်ရန်`,
  register: `စာရင်းသွင်းရန်`,
  username_placeholder: `အသုံးပြုသူအမည်`,
  please_input_your_x: `သင့် {{x}} ကို ထည့်သွင်းပါ`,
  verification_code: `အတည်ပြုကုဒ်`,
  press_get_code: `အတည်ပြုကုဒ်ကို SMS ဖြင့်ရယူရန် GET CODE ခလုတ်ကိုနှိပ်ပါ`,
  otp_sent: `အတည်ပြုကုဒ် ပို့ပြီးပါပြီ! ဆက်လက်ရန် အောက်တွင်အတည်ပြုကုဒ်ကို ထည့်သွင်းပါ`,
  your_otp_expire: `သင့် OTP သည် ရက်လယ်မှာ ပျက်ကွက်ပါလိမ့်မည်`,
  get_code: `GET CODE`,
  didnt_receive: `သတင်းစာကို မရရှိပါသလား?`,
  send_again: `တစ်ခါတည်း ပို့ပါ`,
  captcha: `CAPTCHA`,
  forgot_password: `စကားဝှက်မေ့နေပါသလား`,
  minor_note: `ဒီဆိုက်ကိုလည်ပတ်ရန် သင်သည် 18 နှစ်အရွယ်ဖြစ်ရပြီး ၎င်း၏ ကိုင်တွယ်ခြင်းကို လက်ခံရမည်`,
  terms_of_service: `ဝန်ဆောင်မှုအတွက် စည်းမျဉ်းများ`,
  by_signing_in: 'အကောင့်သို့ဝင်ရုံ သို့မဟုတ် စာရင်းသွင်းပြီးသည့်အခါ သင့်အားလက်ခံရမည့်အရာများကို လက်ခံပါသည်',
  dont_have_account: `အကောင့်မရှိသေးပါသလား?`,
  sign_up: `စာရင်းသွင်းပါ`,
  username: `အသုံးပြုသူအမည်`,
  email: `အီးမေးလ်`,
  full_name: `အပြည့်အစုံအမည်`,
  confirm_18: `ကျွန်တော်/ကျွန်မသည် 18 နှစ်အရွယ်ဖြစ်ပြီး ၎င်း၏ ကိုင်တွယ်ခြင်းကို ဖတ်ပြီးပါပြီ`,
  already_have_account: `အကောင့်ရှိပါပြီလား?`,
  deposit: `ချေးငွေပေးဝေ`,
  bonus: `ဘိုနပ်စ်`,
  load_more: `နောက်ထပ်စတင်ပါ`,
  responsible_gaming: `တာဝန်ရှိသောဂိမ်းကစားမှု`,
  faq: `မေးမြန်းခွင့်`,
  amount: `ပမာဏ`,
  extra: `ပို၍`,
  deposit_bonus: `ချေးငွေဘိုနပ်စ်`,
  withdraw: `ငွေထုတ်ရန်`,
  min: `အနည်းဆုံး:`,
  max: `အများဆုံး:`,
  notifications: `သတိပေးချက်များ`,
  invalid_x: `မမှန်ကန်သော {{x}}`,
  captcha_not_match: `Captcha မတွဲတက်ပါ`,
  invalid_x_must_be_atleast_y_characters: `မမှန်ကန်သော {{x}}, အနည်းဆုံး {{y}} အက္ခရာများ ရှိရမည်`,
  x_is_required: `{{x}} အရေးကြီးပါသည်`,
  phone_number: 'ဖုန်းနံပါတ်',
  phone_num_x_max: `ဖုန်းနံပါတ်တွင် {{x}} အက္ခရာများသာ ရရှိနိုင်ပါသည်`,
  email_sent: `အီးမေးလ်ပို့ပြီးပါပြီ၊ သင့်အီးမေးလ်ကို စစ်ဆေးပါ`,
  enter_valid_email: `ကျေးဇူးပြု၍မှန်ကန်သောအီးမေးလ်တစ်ခု ထည့်သွင်းပါ`,
  confirm: `အတည်ပြုပါ`,
  password_atleast_6_characters: `စကားဝှက်တွင်အနည်းဆုံး 6 အက္ခရာရှိရမည်`,
  password_reset_success: `စကားဝှက် ပြန်လည်သတ်မှတ်ခြင်း အောင်မြင်ပါသည်!`,
  new_password: `အသစ်သောစကားဝှက်`,
  bank: 'ဘဏ်',
  bank_name: `ဘဏ်အမည်`,
  bank_branch: `ဘဏ်ခွဲ`,
  pay_id: `Pay ID`,
  account_name: `အကောင့်အမည်`,
  account_number: `အကောင့်နံပါတ်`,
  drop_or_select: `ဖိုင်ကိုအိပ်ထားပါသို့မဟုတ်ရွေးချယ်ပါ`,
  drop_files_here: `ဖိုင်များကို ဒီနေရာမှာ အိပ်ထားပါ`,
  transfer_to: `သွင်းပါ`,
  upload_receipt: `လက်ခံချက်တင်ပါ`,
  select_bonus: `ဘိုနပ်စ်ရွေးချယ်ပါ`,
  no_promotion: `လျှောက်ထားသောပရိုမိုးရှင်းမရှိပါ`,
  please_upload_receipt: `လက်ခံချက်တင်ပါ`,
  bank_account: `ဘဏ်အကောင့်`,
  add_account: `အကောင့်ထည့်ပါ`,
  account_holder_name: `အကောင့်ပိုင်ရှင်အမည်`,
  name_of_the_account_holder: `အကောင့်ပိုင်ရှင်အမည်`,
  fill_in_bank_account: `ဘဏ်အကောင့်ဖြည့်ပါ`,
  withdraw_information: `ငွေထုတ်ခြင်းသတင်းအချက်အလက်`,
  note: `မှတ်ချက်`,
  amount_withdrawn: `ထုတ်ယူသောပမာဏ`,
  amount_no_exceed_balance: `ထုတ်ယူရန် ပမာဏသည် ရှိသော ပုံမှန်ငွေပမာဏထက်ပိုမထားရပါ`,
  minimum_withdraw_amount_is_x: `အနည်းဆုံးငွေထုတ်ပမာဏမှာ {{x}} ဖြစ်ပါသည်`,
  transaction_history: `ငွေပေးချေမှုသမိုင်း`,
  date_from: `ရက်စွဲမှ`,
  date_to: `ရက်စွဲအထိ`,
  account_name_must_be_4: `အကောင့်အမည်မှာ 4 အက္ခရာများထက်ကြီးရမည်`,
  minimum_length_is_x: `အနည်းဆုံးအကြိမ်နှုန်းမှာ {{x}}`,
  maximum_length_is_x: `အများဆုံးအကြိမ်နှုန်းမှာ {{x}}`,
  payment_method: `ငွေပေးချေမှုနည်းလမ်း`,
  no_bank_account: `သင့်မှာငွေထုတ်ရန်အတွက် ဘဏ်အကောင့်မရှိပါ၊ ယခုထည့်ပါ`,
  bet_history: `အမ်းခြေမှုသမိုင်း`,
  game_provider: `ဂိမ်းပံ့ပိုးသူ`,
  bet_count: `အမ်းခြေမှုအရေအတွက်`,
  win_loss: `အနိုင်/ဆုတ်`,
  rebate: `ကမ်းလှမ်းမှု`,
  turnover: `တည်မြဲမှု`,
  game_category: `ဂိမ်းအမျိုးအစား`,
  you_have_x_unread_messages: `သင်တွင် {{x}} မဖတ်ရသေးသော စာများရှိပါသည်`,
  deposit_amount_between_x_and_y: `ချေးငွေပမာဏသည် {{x}} နှင့် {{y}} အကြားဖြစ်ရမည်`,
  minimum_amount_is_x_y: `အနည်းဆုံးပမာဏမှာ {{x}} {{y}} ဖြစ်ရမည်`,
  all: `အားလုံး`,
  title: `ခေါင်းစဥ်`,
  date: `ရက်စွဲ`,
  type: `အမျိုးအစား`,
  status: `အခြေအနေ`,
  remark: `မှတ်ချက်`,
  category: `အမျိုးအစား`,
  please_select_x: `ကျေးဇူးပြု၍ {{x}} ကို ရွေးချယ်ပါ`,
  save: `သိမ်းဆည်းပါ`,
  change_password: `စကားဝှက်ပြောင်းပါ`,
  current_password: `လက်ရှိစကားဝှက်`,
  confirm_password: `အသစ်သောစကားဝှက်ကို အတည်ပြုပါ`,
  submit: `တင်သွင်းပါ`,
  password_changed: `စကားဝှက်ပြောင်းလဲပြီးပါပြီ`,
  x_must_be_y_characters: `{{x}} သည် {{y}} အက္ခရာရှိရမည်`,
  reset_password: `စကားဝှက်ပြန်လည်သတ်မှတ်ပါ`,
  slots: `စလိုက်များ`,
  live_casino: `တိုက်ရိုက်ကာစီနို`,
  clear: `ရှင်းလင်းပါ`,
  search: `ရှာဖွေရန်`,
  new: `အသစ်`,
  logout: `ထွက်ရန်`,
  choose_date: `ရက်စွဲကို ရွေးချယ်ပါ`,
  select_both_date: `ရက်စွဲမှ နှင့် ရက်စွဲအထိ ကို ရွေးချယ်ပါ`,
  from: `မှ`,
  to: `အထိ`,
  apply: `လျှောက်ပါ`,
  promotions: `ပရိုမိုးရှင်းများ`,
  learn_more: `ပိုပြီးလေ့လာပါ`,
  password_doesnt_match: `စကားဝှက်မတူပါ`,
  cancel: `ဖျက်ပါ`,
  confirm_to_pay: `ပေးဆောင်ရန် အတည်ပြုပါ`,
  deposit_amount: `ချေးငွေပမာဏ`,
  loading_please_wait: `လျှောက်နေပါသည်၊ ကျေးဇူးပြု၍ အနည်းငယ်စောင့်ပါ`,
  account: `အကောင့်`,
  profile: `ပရိုဖိုင်`,
  bank_list: `ဘဏ်စာရင်း`,
  in_maintenance: `ပြုပြင်နေသည်`,
  birthday: `မွေးနေ့`,
  birthday_bonus: `မွေးနေ့အတွက် ဘိုနပ်စ်ရယူပါ! 🎉🎁`,
  referral_code: `ဖိတ်ခေါ်ကုဒ်`,
  referral: `ဖိတ်ခေါ်မည်`,
  my_referral: `ကျွန်တော်၏ ဖိတ်ခေါ်မည်`,
  my_claim: `ကျွန်တော်၏ ပြန်လည်လျှောက်လွှာ`,
  claim_profit: `အကျိုးအမြတ်ရယူပါ`,
  available_profit: `ရရှိနိုင်သော အကျိုးအမြတ်`,
  claimed_profit: `ပြန်လည်ရယူထားသော အကျိုးအမြတ်`,
  all_time_profit: `အချိန်တစ်လုံးအတွင်း ရရှိသော အကျိုးအမြတ်`,
  referral_note_on_x: `သင်၏ သူငယ်ချင်းများ {{x}} တွင် ကစားသောအခါ အကျိုးအမြတ် ရယူနိုင်ပါသည်`,
  tier: `အဆင့်`,
  commission: `ကော်မရှင်`,
  referred_member: `ဖိတ်ခေါ်ထားသော အဖွဲ့ဝင်`,
  profit_earned: `ရရှိသော အကျိုးအမြတ်`,
  account_information: `အကောင့်အချက်အလက်`,
  invite_friends: `သူငယ်ချင်းများကို ဖိတ်ခေါ်ပါ`,
  how_it_work: `၎င်းက ဘယ်လိုအလုပ်လုပ်သလဲ?`,
  invite_note: `သင့်ဖိတ်ခေါ်ကုဒ်ကို အသုံးပြု၍ သင့်သူငယ်ချင်းစာရင်းသွင်းသည့်အခါ ထူးခြားသော ဖိတ်ခေါ်ဘိုနပ်စ်များရယူပါ`,
  share_via: `ဤသို့မျှဝေပါ`,
  referral_link: `ဖိတ်ခေါ်လင့်ခ်`,
  total_profit: `စုစုပေါင်းအကျိုးအမြတ်`,
  copied: `ကူးယူပြီး`,
  nothing_to_claim: `ပြန်လည်တောင်းဆိုရန်မရှိပါ`,
  claim_history: `ပြန်လည်တောင်းဆိုမှုသမိုင်း`,
  downline: `အောက်ပိုင်း`,
  last_x_digit_bank_ref_number: `ဘဏ်အရည်အချင်းရည်ညွှန်းနံပါတ်၏ နောက်ဆုံး {{x}} အက္ခရာ`,
  bank_ref_number_validation_x: `ဘဏ်အရည်အချင်းရည်ညွှန်းနံပါတ်သည် လိုအပ်ပြီး {{x}} အက္ခရာရှိရမည်`,
  login_directly: `တိုက်ရိုက်ဝင်ရန်`,
  our_game_provides: `ကျွန်တော်တို့၏ ဂိမ်းပံ့ပိုးသူများ`,
  linked_successfully_x: `{{x}} နှင့်အောင်မြင်စွာ ချိတ်ဆက်ပြီးပါပြီ! သင့်အကောင့်ကို ပထမဆုံးအကြိမ်စာရင်းသွင်းပါ`,
  more_x_of_y: `ပို၍ {{x}}/{{y}}`,
  agent: 'အေးဂျင့်',
  download: 'ဒေါင်းလုဒ်',
  popular: 'လူကြိုက်များ',
  claim_bonus: `ဘိုနပ်စ်ရယူပါ`,
  currently_displaying: 'လက်ရှိတွင် {{x}} {{y}} ဂိမ်းများကို {{z}} မှ ပြသနေပါသည်',
  no_results: 'ရလဒ်မတွေ့ပါ',
  please_scan_using_your: `ကျေးဇူးပြု၍ သင်၏`,
  activity_rules: `လုပ်ဆောင်မှုစည်းမျဉ်းများ:`,
  event_instructions: 'အဖြစ်အပျက် အညွှန်းများ',
  agent_p1: 'သင့်ထူးခြားသောလင့်ခ်ကို အက်ပ်များနှင့် လူမှုမီဒီယာများတွင် မျှဝေပါ',
  agent_p2:
    'Facebook, Instagram, Tiktok, Telegram, WhatsApp, YouTube အပါအဝင် အခြားများ၊ အရှိန်မြန်ပြီး လူတိုင်းကို ဖိတ်ခေါ်ပါ၊ သင့်ထူးခြားသောလင့်ခ်မှစာရင်းသွင်းသော ဥပမာအရ လူများသည် သင့်တိုက်ရိုက်အေးဂျင့်များဖြစ်လာပါမည်။ သို့သော် ဂရုတစိုက်ပါ၊ သင့်ဖိတ်ခေါ်သော အသစ်သောအဖွဲ့ဝင်များသည် အမှန်တကယ်နှင့် သက်တမ်းရှိသောများဖြစ်ရပါမည်။',
  agent_step1:
    'ဖိတ်ခေါ်သူသည် ပထမဆုံးထည့်သွင်းခြင်းအောင်မြင်ပြီးနောက် R$5 ဘိုနပ်စ်ရယူနိုင်ပါသည်၊ ဥပမာ 10 ငယ်ချင်းကို ပထမဆုံးထည့်သွင်းရန် ဖိတ်ခေါ်ပါက R$50 ရရှိနိုင်ပါသည်။ အများဆုံးလူများကို ဖိတ်ခေါ်ရန်နည်းလမ်းများအား ပိုမိုရယူနိုင်ပါသည်။ သင့်ရဲ့ဘိုနပ်စ်နှင့် ကော်မရှင်များသိုလှောင်ထားသောသမိုင်းကို ပရိုမိုးရှင်းစာမျက်နှာတွင် ကြည့်ရှုနိုင်ပါသည်။',
  agent_step2:
    'သင်၏ ဧည့်သည်များ R$1 သို့မဟုတ် ထပ်တိုးပါက ကော်မရှင်ကြီးများရယူနိုင်ပါသည်! သင်သည် 평생ကော်မရှင် 5% အထိရယူနိုင်ပါသည်၊ အပြန်အလှန် ဖိတ်ခေါ်ရန် အကောင်းဆုံးစနစ်ရှိပါသည်! စနစ်သည် မနေ့တစ်နေ့အတွက် ကော်မရှင်ကို နောက်နေ့မနက် 7 နာရီတွင်ရှင်းလင်းပါလိမ့်မည်။',
  agent_step2_1: 'ကော်မရှင်ရယူရန်: ဝင်ရန် - ဖိတ်ခေါ်မှု ပရိုမိုးရှင်း - ကော်မရှင်စုဆောင်းပါ',
  agent_table1: 'စလိုက်၊ ရိုက်နှိပ်၊ blockchain အတွက် ကော်မရှင်နှုန်းထားများမှာ အောက်ပါအတိုင်းဖြစ်ပါသည်။',
  agent_table1_1: 'သုံးစွဲသူ၏ထည့်သွင်းမှု 20၊ ရောင်းဝယ်မှု 200',
  person: 'လူ',
  agent_table2_title1: 'အဖွဲ့ဝင်ကစားမှု',
  agent_table2_title2: 'စလိုက်ဂိမ်းပဲသာ',
  agent_table2_example:
    'ဥပမာ: သင်တွင် အဖွဲ့ဝင် 100 ဦး ရှိပြီး တစ်နေ့အတွင်း ကစားပမာဏကို 1,000,000 reais အထိမှတ်မိပါက ယနေ့ကော်မရှင်မှာ 1,000,000 x 1.20% 12,000 reais ဖြစ်ပါသည်။ တစ်လလျှင် 100,000 ရရှိရန် အလွယ်တကူဖြစ်နိုင်ပါသည်။',
  reminder: 'အတိအကျသတိပေးချက်',
  agent_reminder:
    'IP တူ၊ စက်တူ၊ နာမည်၊ ဘဏ်ကဒ်နှင့် အခြား အချက်အလက်များကို မတူညီသောအဖွဲ့ဝင်တစ်ဦးသာ တစ်ခါတစ်လေကစားနိုင်ပြီး စည်းမျဉ်းများကို ကျင့်သုံးသောသူများသည် အကျိုးအမြတ်မရနိုင်ပါ။',
  agent_step3_1:
    'အဖွဲ့ဝင်များ၏ လုပ်ဆောင်မှုများကို စနစ်မှ အလိုအလျောက် တွက်ချက်ပါသည်၊ ဂရုတစိုက်ပါက IFUN168 မှ လုပ်ဆောင်သည့် အကဲဖြတ်ရလဒ်က အဓိကဖြစ်ပါသည်',
  agent_step3_2: 'သင်၏အဖွဲ့ဝင် အကောင့်/စကားဝှက် မေ့နေပါက ကျွန်တော်တို့၏ 24 နာရီဖောက်သည်ဝန်ဆောင်မှုအသင်းကို ဆက်သွယ်ပါ',
  agent_step3_3: 'IFUN168 သည် ပရိုမိုးရှင်းကို အချိန်မရွေးပြင်ဆင်၊ ချုပ်ကိုင် သို့မဟုတ် ပယ်ဖျက်ရန် အခွင့်အရေးရှိပါသည်',
  agent_step3_4: 'အေးဂျင့်များသည် ကော်မရှင်ဘိုနပ်စ်ရယူနိုင်ပါသည်။ ငွေပိုက်ဆံ သို့မဟုတ် အလွတ်ငွေလက်ခံခြင်းရှိပါသည်',
  agent_step3_5: 'အခမဲ့ဂိမ်းမထိန်းသိမ်းပါ၊ အခမဲ့ဂိမ်းကို ဝယ်ပါ',
  agent_step3_6: 'ဘိုနပ်စ်နှင့် ပိုက်ဆံထည့်သွင်းခြင်းနှင့် ပေါင်းစပ်၍ မရပါ',
  agent_step3_7: 'စလိုက်ဂိမ်းပဲသာရရှိနိုင်ပါသည်',
  promo_concluded: 'ပရိုမိုးရှင်းပြီးပါပြီ! နောက်တစ်နေ့ ပြန်လာပါ!',
  can_only_claim: 'ဘိုနပ်စ်ကို {{x}} မှ {{y}} အချိန်တွင်သာ ရယူနိုင်ပါသည်',
  please_login: 'ဘိုနပ်စ်ရယူရန် သင့်အကောင့်တွင် ဝင်မည်ဖြစ်ပါသည်!',
  back_to_home: 'မှတ်တမ်းမူခွေ သို့ပြန်သွားပါ',
  bonus_claimed: 'ဘိုနပ်စ်ကို ယခင်မှ အတည်ပြုခဲ့ပါသည်!',
  terms_n_conditions: `စည်းမျဉ်းနှင့် ရလဒ်များ`,
  the_activity_x_in: `လုပ်ဆောင်မှု {{x}} တွင်`,
  starts: `အစပြုသည်`,
  ends: `အဆုံးသတ်သည်`,
  list_of_winners: `အောင်လံစာရင်း`,
  days: `ရက်များ`,
  hours: `နာရီများ`,
  minutes: `မိနစ်များ`,
  seconds: `စက္ကန့်များ`,
  apply_now: `ယခုလျှောက်ပါ`,
  number_exists: 'ဤဖုန်းနံပါတ်သည် ရှိပြီးသားဖြစ်သည်!',
  number_not_exists: 'ဤဖုန်းနံပါတ်မှာ မသက်ဆိုင်ပါ!',
  payment_draft:
    'သင်သည် ပေးချေပြီးပြီဆိုပါက ပေးချေမှုကတော့ အချို့အချိန်ကြာမှ ပြီးစီးနိုင်ပါသည်၊ စစ်ဆေးဖို့ ကျေးဇူးပြု၍ စောင့်ပါ',
  downline_name: 'အောက်ပိုင်းအမည်',
  date_joined: 'အကောင့်မတည်ပြုမီ',
  deposit_amount_x_days: 'ချေးငွေပမာဏ ({{x}} ရက်)',
  dont_show_again: 'ထပ်မံပြသမထားပါ',
  next: 'အောက်ပါ',
  close: 'ပိတ်ပါ',
  no_balance: 'အလှည့်မရှိပါ',
  menu: `မီနူး`,
  vip_club: `VIP Club`,
  home: `အိမ်`,
  lobby: `လောဘီ`,
  show_all: `အားလုံးပြသပါ`,
  game_name: `ဂိမ်းနာမည်`,
  sub_filters: `ဖိုင်တာများ`,
  contact_us_24: `24 နာရီ ဖောက်သည်ဝန်ဆောင်မှု ဆက်သွယ်ရန်`,
  live_chat: `တိုက်ရိုက်ဆွေးနွေးပါ`,
  chat_now: `ယခုဆွေးနွေးပါ`,
  gaming_license: `ဂိမ်းလိုင်စင်`,
  certification: `လက်မှတ်`,
  security: `လုံခြုံရေး`,
  threatmetrix: `ThreatMetrix`,
  gaming_license_caption:
    'IFUN168 သည် Curacao ၏ အစိုးရမှ လိုင်စင်ရရှိပြီး စည်းကမ်းထားရှိသော အဖွဲ့အစည်းတစ်ခု ဖြစ်ပြီး Master License of Gaming Services Provider, N.V #365/JAZ ဖြင့် ဥပဒေနှင့်သက်ဆိုင်သော လုပ်ငန်းများကို လုပ်ကိုင်ပါသည်။',
  no_limits: 'ကန့်သတ်မှုမရှိပါ',
  vip_description_no_limits:
    'ကျွန်ုပ်တို့သည် VIP club တွင် ဂိမ်းရောဂါအခြေအနေများနှင့် မတူကွဲပြားသော VIP ဝန်ဆောင်မှုများကို ကစားသမားအားလုံးကို ပေးသည်။ ယခု သင်သည် စိုးရိမ်စရာမရှိပဲ ကစားနိုင်ပါသည်! အလွန်ရိုးရှင်းပါသည် - လှုပ်ရှားမှုအတွက် ကစားပါ၊ ဂိမ်းစွမ်းရည်တိုးတက်အောင် လေ့လာပါ၊ အချိန်ကို ပျော်စရာဖြင့် ဖြတ်သန်းပါ၊ နှင့် အကျိုးအမြတ်အတွက် ကန့်သတ်မှုမရှိပါ။',
  financial_privileges: 'ငွေကြေးအကျိုးခံစားခွင့်များ',
  vip_description_financial_privileges:
    'VIP club သည် ထူးခြားသော VIP ဝန်ဆောင်မှုများကို လိုအပ်သော ကစားသမားအားလုံးကို လက်ခံပါသည်။ အထူးကမ်းလှမ်းချက်များ၊ ဂျက်မဲ့ဖြစ်သော မြှင့်တင်မှုများနှင့် အကျိုးအမြတ်များကို ကျွန်ုပ်တို့၏ ဝက်ဘ်ဆိုက်တွင် ရယူနိုင်ပါသည်! VIP ကစားသမား၏ အဆင့်သည် ငွေပေးချေမှုများအား အချိန်တိုင်းထဲတွင် လျင်မြန်စွာ အမြင့်ဆုံး ထုတ်ယူလက်မှတ်များကို ဖွင့်ပေးပါသည်! ပျော်ပါ!',
  personal_manager: 'ပုဂ္ဂိုလ်ရေးမန်နေဂျာ',
  vip_description_personal_manager:
    'VIP ကစားသမားဖြစ်လာပါက ဘယ်အကျိုးတစ်ခုကို ရယူလိုပါသလဲ? သင်၏ ပုဂ္ဂိုလ်ရေးမန်နေဂျာနှင့် သင်၏ အတွေးများကို ပေးပို့ပြီး ကျွန်ုပ်တို့၏ ဝက်ဘ်ဆိုက်တွင် မည်သည့် အကျိုးအမြတ်ကို ပိုမို မြှင့်တင်လိုပါသလဲဆိုတာ ဆွေးနွေးပါ။ ကျွန်ုပ်တို့သည် မိတ်ဆွေသစ်များအတွက် မဖြစ်နိုင်သော အကြံပြုချက်များကို လက်ခံပါသည်!',
  vip_promotions: 'VIP မြှင့်တင်မှုများ',
  vip_description_vip_promotions:
    'သင်သည် အလွန်သကတျသော VIP ကစားသမားများကို အကျိုးအမြတ်နှင့် အကျိုးအမြတ်များအတွက် လိုက်လျောညီထွေသော လျော်ကြေးများကို လက်ခံလိုပါသလား? အားလုံးကို အကျိုးရှိသောကစားသမားများဖြစ်ကြပါစေ!',
  withdraw_limit: 'ထုတ်ယူသတ်မှတ်ချက်',
  monthly: 'လ',
  weekly: 'အပတ်စဉ်',
  annual: 'နှစ်စဉ်',
  cashback: 'ငွေပြန်အမ်း',
  personal_account_manager: 'ပုဂ္ဂိုလ်ရေးအကောင့်မန်နေဂျာ',
  yes: 'ဟုတ်ပါသည်',
  join_the_vip: 'VIP အစီအစဉ်ကို ယခုအခါ သင်လည်း ပါဝင်ပါ!',
  join_now: 'ယခုပါဝင်ပါ',
  play_the_way_you_want: 'သင့်လိုချင်သလို ကစားပါ',
  more_info: 'ပိုမိုသိရန်',
  nothing_to_show: 'ပြသရန်မရှိပါ',
  remarks: 'မှတ်ချက်များ',
  password: 'စကားဝှက်',
  back: 'ပြန်သွားပါ',
  new_to_x: '{{x}} တွင် အသစ်ပါ',
  create_an_account: 'အကောင့်ဖွင့်ပါ',
  withdraw_amount: 'ထုတ်ယူပမာဏ',
  balance: 'လက်ကျန်',
  bank_bsb: 'ဘဏ် BSB',
  enter_bank_branch: 'ဘဏ်ဌာနအမည် ထည့်ပါ',
  enter_pay_id: 'Pay ID ထည့်ပါ',
  level: 'အဆင့်',
  claimed: 'ပူးတွဲပြန်လည်ရှာဖွေပြီး',
  not_found: 'မတွေ့ပါ',
  become_a_vip: 'VIP ဖြစ်ပါ',
  otp_not_found: 'OTP မထည့်သွင်းထားပါ',
  resend_again: 'ပြန်ပို့ပါ',
  how_to_get_referral_bonus: 'ကိုယ်စားလှယ်သူ ငွေပေးချေမှု ဘယ်လိုရယူရမလဲ?',
  steps_to_claim: 'အကျိုးအမြတ် ရယူရန်အဆင့်များ',
  share_your_referral_code:
    '1. ကိုယ်စားလှယ်ကုဒ်ကို သူငယ်ချင်းများနှင့် ဖေ့စ်ဘုတ်၊ တွစ်တာ၊ ဒါမှမဟုတ် ဝါ့တ်စပ်ဖြင့် ပေးပို့ပါ။',
  after_friend_register:
    '2. သူငယ်ချင်းသည် IFUN168 တွင် အကောင့်မှတ်ပုံတင်ပြီးနောက်၊ ကိုယ်စားလှယ်နှင့် ကိုယ်စားလှယ်ဝင်များသည် ငွေသွင်းပြီး အကျိုးအမြတ်ကို ရယူရမည်။',
  refer_a_friend_bonus: '3. ကိုယ်စားလှယ်သူ ငွေပေးချေမှုတွက်ချက်ချက်:',
  turnover_played: 'Turnover ကစားသည့် x Commision % = ကိုယ်စားလှယ်သူ ငွေပေးချေမှု',
  example: 'ဥပမာ:',
  turnover_formula_x: 'Turnover (1,000,000) x 0.002% (Commission %) = 2,000{{x}}',
  note_bonus_only: '*မှတ်ချက်: ငွေပေးချေမှုကို နောက်တစ်ရက် 12:00am မှတစ်ပါတ်သာ ရယူနိုင်ပါသည်',
  note_bonus_only_x: '*မှတ်ချက်: ငွေပေးချေမှုကို {{x}} အချိန်အတည်ပြုမှ နောက်တစ်ရက်တွင်သာ ရယူနိုင်ပါသည်',
  access_dashboard:
    '4. အခွင့်အလမ်းများကို စစ်ဆေးရန် Dashboard ကို ဝင်ရောက်ပါ၊ commision tier ကို စစ်ဆေးပါ၊ အကျိုးအမြတ်သမားနှင့် အခြားသွားလမ်းများကို စစ်ဆေးပါ။',
  highlights: 'အထူးသဖြင့်',
  event: 'ပွဲ',
  information: 'အချက်အလက်',
  casino: 'ကာစီနို',
  fish: 'ငါး',
  sports: 'အားကစား',
  card: 'ကတ်',
  popular_games: 'လူကြိုက်များသော ဂိမ်းများ',
  game_providers: 'ဂိမ်းပေးသွင်းသူများ',
  leaderboard: 'အဆင့်အတန်း',
  winnings: 'အနိုင်',
  vip_member_level: 'VIP အဖွဲ့ဝင်အဆင့်',
  change_language: 'ဘာသာစကားပြောင်းရန်',
  contact: 'ဆက်သွယ်ရန်',
  choose_deposit_method: 'ငွေပေးချေမှုနည်းလမ်းရွေးပါ',
  your_bank_account: 'သင့်ဘဏ်အကောင့်',
  x_games: '{{x}} ဂိမ်းများ',
  x_game: '{{x}} ဂိမ်း',
  fishing: 'ငါးပန်း',
  please_enter_email: 'ကျေးဇူးပြု၍ သင့်အီးမေးလ်ထည့်ပါ',
  please_enter_new_password: 'ကျေးဇူးပြု၍ သင့်လစီသစ်ကို ထည့်ပါ',
  password_not_match: 'စကားဝှက်မကိုက်ညီပါ',
  confirm_new_password: 'လစီသစ်ကို အတည်ပြုပါ',
  must_start_with: 'ဖုန်းနံပါတ်မှာ အနည်းဆုံး ၁၀ နံပါတ်ရှိရမည်နှင့် (01) ဖြင့် စတင်ရမည်',
  first_name: 'ပထမအမည်',
  last_name: 'နောက်ဆုံးအမည်',
  to_proceed_further_add_bank: 'ဆက်လက်ဆောင်ရွက်ရန် သင့်ဘဏ်အချက်အလက်များ ထည့်ပါ',
  please_select_bank: 'ဘဏ်ကို ရွေးချယ်ပါ',
  leave_empty_if_same_as_above: 'အထက်ပါနှင့် တူလျှင် အလွတ်ထားပါ',
  deposit_from_bank: 'ဘဏ်မှ ငွေပေးချေမှု',
  select_language: 'ဘာသာစကားကို ရွေးပါ။',
  logout_confirmation: 'ยืนยันการออกจากระบบ',
  are_you_sure_to_logout: 'คุณแน่ใจว่าต้องการออกจากระบบหรือไม่?',
  congratulations: 'ဂုဏ်ယူပါတယ်',
  spin_the_wheel: 'ဘီးကိုလှည့်ပါ',
  x_lucky_wheel: '{{x}} ကံစမ်းဘီး',
  spin: 'လှည့်မည်',
  you_won_x: 'သင်အနိုင်ရသည် {{x}}',
  coins: 'အကြွေစေ့များ',
  insufficient_coins: 'အကြွေစေ့မလုံလောက်ပါ',
  points: 'အမှတ်များ',
  spin_now: 'အခုလှည့်ပါ',
  nice_try: 'ကြိုးစားမှုကောင်းပါတယ်',
  follow_us: 'ကြှနျုပျတို့နောကျလိုကျပါ',
};

export default my;
